export default __webpack_public_path__ + "c31ed1f9aa0c32e84d9e74e48b9b2a48.jpg";